import { useApp, usePopUpMessage, usePracticeAccess } from '@hb/react'
import { CreateNewAssessmentArgs } from '@hb/shared'
import { useCallback, useState } from 'react'
import { createNewAssessment } from '../../backend/functions/assessments'
import { useProfile } from '../../contexts/user/ProfileContext'

export const useCreateAssessment = () => {
  const { user, goTo: goTo } = useProfile()

  const { appName } = useApp()
  const { selectedPracticeId } = usePracticeAccess()
  const { processResponse } = usePopUpMessage()
  const [confirmingNewAssessment, setConfirmingNewAssessment] = useState(false)
  const [addLoading, setAddLoading] = useState(false)
  const createAssessment = useCallback(
    async (data: CreateNewAssessmentArgs) => {
      const { name, sendInvite, copyPreviousData, copyFromPregnancyId, notes, edd } = data
      if (!user) {
        return processResponse({
          error: 'No user selected to create assessment for',
        })
      }
      // if (!name && appName === 'app') {
      //   return processResponse({ error: 'No assessment name entered' })
      // }
      if (appName === 'providers-app' && !edd) {
        return processResponse({ error: 'No EDD entered' })
      }
      if (appName === 'providers-app' && !selectedPracticeId) {
        return processResponse({
          error: 'No practice selected to create assessment for',
        })
      }
      setAddLoading(true)
      try {
        const submitted: Record<string, any> = {
          patientId: user.id,
          name: name ?? '',
          sendInvite,
          notes,
          edd,
          copyPreviousData,
          copyFromPregnancyId,
        }
        if (selectedPracticeId) submitted.practiceId = selectedPracticeId
        const res = await createNewAssessment(submitted)
        if (typeof res.data === 'string') {
          goTo({ entity: { id: res.data, type: 'pregnancy' }, tab: null })
        }
        setAddLoading(false)
        setConfirmingNewAssessment(false)
        return processResponse({ success: 'Pregnancy created!' })
      } catch (err: any) {
        console.error(err?.message)
        setAddLoading(false)
        return processResponse({ error: err.message })
      }
    },
    [user, processResponse, goTo, selectedPracticeId, appName],
  )
  return {
    confirmingNewAssessment,
    setConfirmingNewAssessment,
    addLoading,
    createAssessment,
  }
}
